<div class="modal-header">
    <h5 class="modal-title" id="exampleModalLabel">Dodaj/Edytuj wiadomość</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="modalRef.close()"></button>
</div>
<div class="modal-body">
    <form [formGroup]='form' (ngSubmit)='submit()'>
        <div class="flex-row mb-2">
            <label class="form-label" for="name">Tekst:</label>
            <div class="NgxEditor__Wrapper">
                <ngx-editor-menu [editor]="editor_text" [toolbar]="toolbar"> </ngx-editor-menu>
                <ngx-editor [editor]="editor_text" [ngModel]="html_text" [disabled]="false" [placeholder]="'Wpisz tutaj...'" class="form-control" id="text" formControlName="text"></ngx-editor>
            </div>
        </div>
        <div class="flex-row mb-2">
            <mat-slide-toggle id="priority" formControlName="priority">Ogłoszenie priorytetowe</mat-slide-toggle>
        </div>
        <div class="flex-row mb-2">
            <label>
                <input type="file" class="text-nowrap text-truncate" (change)="selectFile($event)" />
            </label>
            <button class="btn btn-success btn-sm" [disabled]="!selectedFiles" (click)="upload()">
                Wyślij plik
            </button>
            <div *ngIf="currentFileUpload" class="progress mt-2">
                <div class="progress-bar progress-bar-info" role="progressbar" attr.aria-valuenow="{{ percentage }}" aria-valuemin="0" aria-valuemax="100" [ngStyle]="{ width: percentage + '%' }">
                    {{ percentage }}%
                </div>
            </div>
            <div *ngIf="parentToEdit?.fileName && !currentFileUpload" class="mt-2">
                <small>Obecny plik: {{parentToEdit?.fileName}}</small>
            </div>
            <div *ngIf="currentFileUpload" class="mt-2">
                <small>Wybrany plik: {{currentFileUpload.name}}</small>
            </div>
        </div>
        <div class="flex-row mb-2">
            <button class="btn btn-success" type="submit" (click)="modalRef.close()">{{operationText()}}</button>
        </div>
    </form>
</div>